import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=641cdad4&scoped=true&lang=pug&"
import script from "./chat.vue?vue&type=script&setup=true&lang=js&"
export * from "./chat.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./chat.vue?vue&type=style&index=0&id=641cdad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641cdad4",
  null
  
)

export default component.exports